import { render } from "./PetHeight.vue?vue&type=template&id=3f51cc4c&scoped=true"
import script from "./PetHeight.vue?vue&type=script&lang=js"
export * from "./PetHeight.vue?vue&type=script&lang=js"

import "./PetHeight.vue?vue&type=style&index=0&id=3f51cc4c&scoped=true&lang=css"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f51cc4c"]])

export default __exports__